export const fourRetailConfiguration = {
  four_retail_configurations: `Configuraciones de 4Retail`,
};
